module.exports = __webpack_public_path__ + "static/media/artist-circle.f71aa96e.png";